import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import { Checkbox, Group, Stack, TextInput } from '@mantine/core';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import { NumericFormat } from 'react-number-format';

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

export class GeneralDialogueBoxModal extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE
  };
  
  constructor(props) {
    super(props);
  }
  
  render() {
    const { open, toggle, className, next, hideNext=false, mainText, buttonsPosition='space-between', headingClassName='', heading='', mainTextStyling, closeButtonText='Abbrechen', nextButtonText='Fortfahren', nextButtonClassname='purple-btn', closeButtonClassname='gray-btn' } = this.props;
    
    return (
      <CustomModal
        heading={heading}
        headingClassName={headingClassName}
        open={open}
        toggle={() => toggle()}
        className={`${className}`}
      >
        <Stack>
            <Group>
              <p style={{...{fontFamily: 'Inter, sans-serif', fontWeight: '400'}, ...mainTextStyling}}>{mainText}</p>
            </Group>
            <Group justify={buttonsPosition}>
                <div>
                    <ColorButton
                    text={closeButtonText}
                    className={closeButtonClassname}
                    onClick={()=> toggle()}
                    />
                </div>
                {!hideNext &&
                <div>
                    <ColorButton
                    text={nextButtonText}
                    className={nextButtonClassname}
                    onClick={()=> next()}
                    />
                </div>}
            </Group>
        </Stack>
      </CustomModal>
    );
  }
}

export default GeneralDialogueBoxModal;
